






































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import AssignTableGroups from './AssignTableGroups/AssignTableGroups.vue';
import AssignTableCircuits from './AssignTableCircuits/AssignTableCircuits.vue';
import AssignTableLamps from './AssignTableLamps/AssignTableLamps.vue';
import AssignRulesList from './AssignRulesList/AssignRulesList.vue';
import AssignSettings from './AssignSettings/AssignSettings.vue';
import ScenarioElementModal from './ScenarioElementModal/ScenarioElementModal.vue';
import { ScenariosAction, ScenariosActionType, ScenariosState } from '@/store/modules/scenarios/types';
import {
  UserGetter, UserGetterType
} from '@/store/modules/admin/types';
import { BffSettings } from '@/api/bff';

enum ScenariosTabs {
  Rules = 'rules',
  Groups = 'groups',
  Circuits = 'circuits',
  Lamps = 'lamps',
  Settings = 'settings',
}

const scenarios = namespace('scenarios');
const admin = namespace('admin');

@Component({
  components: {
    AssignRulesList,
    AssignTableGroups,
    AssignTableCircuits,
    AssignTableLamps,
    AssignSettings,
    ScenarioElementModal,
  }
})
export default class PlanningCardRightSidePanel extends Vue {
  selectedTab: ScenariosTabs = ScenariosTabs.Rules

  get tabs() {
    return [
      { name: this.$tc('main.scenarioRule', 2), value: ScenariosTabs.Rules },
      { name: this.$tc('main.group', 2), value: ScenariosTabs.Groups },
      { name: this.$tc('main.circuit', 2), value: ScenariosTabs.Circuits },
      { name: this.$tc('main.lamp', 2), value: ScenariosTabs.Lamps },
      { name: this.$tc('main.settings', 2), value: ScenariosTabs.Settings },
    ];
  }

  searchPhrase = ''

  showModal = false

  cardSettings: Record<string, boolean> = {}

  @scenarios.State
  scenarios!: ScenariosState['scenarios']

  @scenarios.State
  selectedScenarioUuid!: ScenariosState['selectedScenarioUuid']

  @scenarios.State
  selectedScenarioElementID!: ScenariosState['selectedScenarioElementEditID']

  @scenarios.State
  selectedScenarioElementUuid!: ScenariosState['selectedScenarioElementEditUuid']

  @scenarios.State
  selectedScenarioID!: ScenariosState['selectedScenarioID']

  @scenarios.Action(ScenariosAction.SetSelectedScenarioElementID)
  setSelectedScenarioElementID!: ScenariosActionType['SET_SELECTED_SCENARIO_ELEMENT_ID']

  @scenarios.Action(ScenariosAction.SetSelectedScenarioElementUuid)
  setSelectedScenarioElementUuid!: ScenariosActionType['SET_SELECTED_SCENARIO_ELEMENT_UUID']

  @admin.Getter(UserGetter.GetPermissions)
  GetPermissions!: UserGetterType['GET_PERMISSIONS'];

  @scenarios.Action(ScenariosAction.FetchScenarioElementsByScenario)
  fetchScenarioElementsByScenario!: ScenariosActionType['FETCH_SCENARIO_ELEMENTS_BY_SCENARIO'];

  @scenarios.Action(ScenariosAction.SetSelectedScenarioHasConnections)
  SetSelectedScenarioHasConnections!: ScenariosActionType['SET_SELECTED_SCENARIO_HAS_CONNECTIONS'];

  @Watch('selectedScenarioElementID')
  onSelectedScenarioElementIDChange(scenarioElementId: number) {
    if (scenarioElementId) this.showModal = true;
  }

  get isDefaultScenario() {
    const isDefaultUuid = this.scenarios.find((s) => s.is_default)?.uuid;
    if (this.selectedScenarioUuid === isDefaultUuid) return true;
    return false;
  }

  get isScenarioSelected() {
    return !!this.selectedScenarioID;
  }

  get writePermission() {
    const getPermissions = this.GetPermissions.find((item) => item.type === 'scenarios');
    return getPermissions.write;
  }

  get deletePermission() {
    const getPermissions = this.GetPermissions.find((item) => item.type === 'scenarios');
    return getPermissions.delete;
  }

  get scenarioChangeConfirmation() {
    return this.cardSettings['planning.scenarioChangeConfirmation'] ?? false;
  }

  addScenarioElement() {
    this.setSelectedScenarioElementUuid(null);
    this.showModal = true;
  }

  @Watch('selectedScenarioUuid')
  onSelectedScenarioUuidChange() {
    this.SetSelectedScenarioHasConnections(null);
  }

  async fetchCardSettings() {
    try {
      this.cardSettings = await BffSettings.getCardSettings();
    } catch (err) {
      console.error('Failed to load card settings:', err);
      this.cardSettings = {};
    }
  }

  async mounted() {
    await this.fetchCardSettings();
  }
}
